module.exports = __webpack_public_path__ + "static/media/europeanroulette.00f1f2f6.jpeg";